module.exports = __webpack_public_path__ + "img/botImg.b4a2ee16.png";